import styled from 'styled-components';
import { styleSizes } from 'constants/styleSizes';

export const FieldsRow = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;

  .countryProvinceField {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: ${styleSizes.mobileBreakpoint}) {
    flex-direction: column;
    gap: 0;
  }
`;